import { siteConfig } from "../../constants/config"

export const config = {
  resendDuration: 120,
  otpCount: 6,
  defaultLang: "en",
  ...siteConfig,
}
